import axios from "axios";
import { api_url } from "../config/constants";

const useCdvActions = () => {

  const search = (docId) => {
    return axios.get(`${api_url}/verifyDocumentId?cdvRequest=${docId}`);
  }
  return {
    search
  }
}

export default useCdvActions;